import React from "react"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData, selectedReportTypeTab } from "Pages/ReportsAlerts/Reports/@signals"
import { array, object } from "yup"
import { AppSitesAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"
import { REPORT_TYPE_SITE_FILTERS } from "Pages/ReportsAlerts/Reports/@constants"

export default function SitesField({ url = `${BACKEND_APIS.MASTER_DATA}/options/site` }) {

	const {
		sites,
		setSitesInfo,
		error
	} = useReportFormInfo(reportFormData.peek().sites, "sites", object({ sites: array().required("Must provide a site").min(1, "Must provide a site") }))

	const siteFilters = REPORT_TYPE_SITE_FILTERS[selectedReportTypeTab.value]

	return <AppSitesAutocomplete
		multiple
		label="Site"
		placeholder="Select a Site"
		value={sites || []}
		error={error}
		onChange={e => setSitesInfo(e.target.value)}
		urlAjax={url}
		{...(siteFilters && { filters: siteFilters })}
	/>
}